import noReportListReducer from "./noReportListReducer";

const noReportReducers = {
    noReportList: noReportListReducer
};

export default noReportReducers;